import React from 'react';
import { Empty } from 'antd';
import './ResponsiveDataCards.css';

export default function ResponsiveDataCards({
   dataSource = [],
   fields = [],
   rowKey = 'id',
   renderActions,
   emptyDescription = 'No records found',
   className = '',
}) {
   if (!Array.isArray(dataSource) || dataSource.length === 0) {
      return (
         <div className={`responsive-data-cards-empty ${className}`.trim()}>
            <Empty image="../images/brainee_mascot.png" description={emptyDescription} />
         </div>
      );
   }

   return (
      <div className={`responsive-data-cards ${className}`.trim()}>
         {dataSource.map((record, index) => {
            const cardKey = record?.[rowKey] ?? record?.id ?? index;

            return (
               <article className="responsive-data-card" key={cardKey}>
                  <div className="responsive-data-card-fields">
                     {fields.map((field) => {
                        const dataIndex = field.dataIndex ?? field.key;
                        const rawValue = dataIndex ? record?.[dataIndex] : undefined;
                        const isEmptyValue = rawValue === null || rawValue === undefined || rawValue === '';

                        if (field.hideIfEmpty && isEmptyValue) {
                           return null;
                        }

                        const content = field.render
                           ? field.render(rawValue, record, index)
                           : (isEmptyValue ? '-' : rawValue);
                        const fieldClassName = [
                           'responsive-data-card-field',
                           field.span === 2 ? 'is-full' : '',
                           field.emphasis ? 'is-emphasis' : '',
                        ].filter(Boolean).join(' ');

                        return (
                           <div className={fieldClassName} key={`${cardKey}-${field.key || dataIndex || field.label}`}>
                              <span className="responsive-data-card-label">{field.label}</span>
                              <span className="responsive-data-card-value">{content}</span>
                           </div>
                        );
                     })}
                  </div>

                  {renderActions && (() => {
                     const actions = renderActions(record, index);

                     if (!actions) {
                        return null;
                     }

                     return (
                        <div className="responsive-data-card-actions">
                           {actions}
                        </div>
                     );
                  })()}
               </article>
            );
         })}
      </div>
   );
}
